(() => {
  const root = (window.KOMModules = window.KOMModules || {});

  root.setupContactMap = () => {
    const mapNode = document.querySelector('[data-contact-map]');
    if (!mapNode || typeof window.L === 'undefined') {
      return;
    }

    const lat = Number(mapNode.getAttribute('data-lat') || '43.295369');
    const lng = Number(mapNode.getAttribute('data-lng') || '-2.2566447');
    const zoom = Number(mapNode.getAttribute('data-zoom') || '17');

    const map = window.L.map(mapNode, {
      center: [lat, lng],
      zoom,
      zoomControl: false,
      attributionControl: false,
      dragging: false,
      touchZoom: false,
      doubleClickZoom: false,
      scrollWheelZoom: false,
      boxZoom: false,
      keyboard: false,
      tap: false
    });

    window.L.tileLayer('https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png', {
      subdomains: 'abcd',
      maxZoom: 20
    }).addTo(map);

    map.createPane('labels');
    const labelsPane = map.getPane('labels');
    if (labelsPane) {
      labelsPane.style.pointerEvents = 'none';
      labelsPane.style.zIndex = '650';
    }

    window.L.tileLayer('https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}{r}.png', {
      subdomains: 'abcd',
      maxZoom: 20,
      pane: 'labels',
      opacity: 0.85
    }).addTo(map);

    setTimeout(() => map.invalidateSize(), 80);
  };

  root.setupMuseumLightbox = () => {
    const links = Array.from(document.querySelectorAll('.museum-glightbox'));
    if (links.length === 0) {
      return;
    }

    const createGallery = () => {
      if (typeof window.GLightbox !== 'function') {
        return null;
      }

      return window.GLightbox({
        selector: '.museum-glightbox',
        loop: true,
        touchNavigation: true,
        closeButton: true,
        openEffect: 'zoom',
        closeEffect: 'fade',
        slideEffect: 'slide',
      });
    };

    let gallery = createGallery();

    links.forEach((link, index) => {
      link.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (!gallery) {
          gallery = createGallery();
        }

        if (gallery && typeof gallery.openAt === 'function') {
          gallery.openAt(index);
        }
      });
    });
  };

  root.setupAsyncLeadForm = () => {
    const form = document.querySelector('form[data-async-lead]');
    if (!form) {
      return;
    }

    const statusNode = document.querySelector('[data-lead-form-status]');
    const formBody = document.querySelector('[data-lead-form-body]');
    const thanksNode = document.querySelector('[data-lead-form-thanks]');
    const submitButton = form.querySelector('button[type="submit"]');

    // Garantiza estado inicial consistente (evita mostrar formulario y gracias a la vez).
    if (thanksNode) {
      thanksNode.hidden = true;
    }
    if (formBody) {
      formBody.hidden = false;
    }

    const renderStatus = (text, type) => {
      if (!statusNode) {
        return;
      }

      statusNode.hidden = false;
      statusNode.textContent = text;
      statusNode.classList.remove('admin-alert-success', 'admin-alert-error', 'admin-alert-warning');
      statusNode.classList.add(`admin-alert-${type}`);
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (statusNode) {
        statusNode.hidden = true;
      }

      if (thanksNode) {
        thanksNode.hidden = true;
      }

      if (formBody) {
        formBody.hidden = false;
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const originalLabel = submitButton ? submitButton.textContent : '';
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = submitButton.getAttribute('data-submitting-label') || 'Enviando...';
      }

      try {
        const payload = new FormData(form);
        const response = await fetch(form.action, {
          method: 'POST',
          body: payload,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        const json = await response.json();
        if (!response.ok || !json.ok) {
          const firstError = json && json.errors && typeof json.errors === 'object'
            ? Object.values(json.errors).find((value) => typeof value === 'string' && value.trim() !== '')
            : '';

          renderStatus(firstError || json.message || 'No se ha podido enviar la solicitud.', 'error');
          return;
        }

        form.reset();

        if (statusNode) {
          statusNode.hidden = true;
        }

        if (formBody) {
          formBody.hidden = true;
        }

        if (thanksNode) {
          thanksNode.hidden = false;
          thanksNode.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      } catch (error) {
        renderStatus((error && error.message) || 'No se ha podido enviar la solicitud.', 'error');
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = originalLabel;
        }
      }
    });
  };

  root.setupHeroParallax = () => {
    const mediaImages = Array.from(
      document.querySelectorAll('.hero-home-media img, .museum-hero-media img, .history-hero-media img')
    );

    if (mediaImages.length === 0 || !('requestAnimationFrame' in window)) {
      return;
    }

    const items = mediaImages
      .map((img) => {
        const section = img.closest('.hero-home, .museum-hero, .history-hero, .contact-map');
        if (!section) {
          return null;
        }

        const itemMaxOffset = section.classList.contains('contact-map') ? 24 : 46;

        return { img, section, itemMaxOffset };
      })
      .filter(Boolean);

    if (items.length === 0) {
      return;
    }

    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobileBreakpoint = 940;
    let ticking = false;

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const apply = () => {
      ticking = false;

      if (reducedMotionQuery.matches || window.innerWidth <= mobileBreakpoint) {
        items.forEach(({ img }) => {
          img.style.setProperty('--hero-parallax-offset', '0px');
        });
        return;
      }

      const viewportHeight = window.innerHeight || 1;

      items.forEach(({ img, section, itemMaxOffset }) => {
        const rect = section.getBoundingClientRect();
        const travel = viewportHeight + rect.height;
        const progress = clamp((viewportHeight - rect.top) / (travel || 1), 0, 1);
        const normalized = progress * 2 - 1;
        const offset = clamp(normalized * itemMaxOffset, -itemMaxOffset, itemMaxOffset);

        img.style.setProperty('--hero-parallax-offset', `${offset.toFixed(2)}px`);
      });
    };

    const requestApply = () => {
      if (ticking) {
        return;
      }
      ticking = true;
      requestAnimationFrame(apply);
    };

    window.addEventListener('scroll', requestApply, { passive: true });
    window.addEventListener('resize', requestApply);

    if ('addEventListener' in reducedMotionQuery) {
      reducedMotionQuery.addEventListener('change', requestApply);
    }

    apply();
  };
})();
